import React, { Component, useEffect, useState } from "react";
import { Redirect, withRouter } from "react-router-dom";
import DashBlock from "./../../components/DashBlock";
import CustomTable from "./../../components/CustomTable";
import SummaryTable from "./../../components/CustomTable/SummaryTable";
import CircularProgressbar from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { changeIndexToNepali, colorScale } from "../../utils";
import Api from "../../services/api";
import "./style.css";
import ProgressBar from "../../components/ProgressBar";
import provinceMapJson from "../../assets/geoJson/province.json";
import localMapJson from "../../assets/geoJson/local.json";
import {
  Radar,
  Legend,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from "recharts";
import { BounceLoader } from "react-spinners";
import { Row, Col, Input, FormGroup } from "reactstrap";

function Home1(props) {
  const [data, setData] = useState();
  const [activeTab, setActiveTab] = useState("local");
  const [activeData, setActiveData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [checkData, setCheckData] = useState([]);
  const [catData, setCatData] = useState([]);
  const [topData, setTopData] = useState([]);
  const [latestData, setLatestData] = useState([]);
  const [summary, setSummary] = useState([]);
  const [fyId, setFyId] = useState(localStorage.getItem("fyId"));
  const [fyList, setFyList] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);

  const toogle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const _getFiscalyear = async () => {
    const fy = await Api.getFyList();
    setFyList(fy.response);
  };

  const _getCategories = async () => {
    const cat = await Api.getCategories();
    setCategories(cat.response);
  };

  const _getSubCategories = async (id) => {
    const subCat = await Api.getSubCategories(id);
    setSubCategories(subCat.response);
  };

  const _getHomeData = async () => {
    setIsLoading(true);
    const home = await Api.getHomeData({
      fiscal_year_id: fyId,
      province_id: 2,
    });
    setActiveData(home.response.nepal);
    setCheckData(home.response.stat);
    setCatData(home.response.categories);
    setTopData(home.response.top_palikas);
    setLatestData(home.response.least_palikas);
    setSummary(home.response.evaluation_summary);
    setIsLoading(false);
  };

  const _getHomeDataFilter = async (params) => {
    setIsDataLoading(true);
    const home = await Api.getHomeData(params);
    setActiveData(home.response.nepal);
    setCheckData(home.response.stat);
    setCatData(home.response.categories);
    setTopData(home.response.top_palikas);
    setLatestData(home.response.least_palikas);
    setSummary(home.response.evaluation_summary);
    setIsDataLoading(false);
  };

  const _handleFiscalYearChange = async (e) => {
    let fiscalYearId = e.target.value;
    setFyId(fiscalYearId);
    let params = {
      fyId: fiscalYearId,
      provinceId: sessionStorage.getItem("provinceId"),
    };
    localStorage.setItem("fiscalYear", fiscalYearId);
    _getHomeDataFilter(params);
    setIsDataLoading(false);
  };

  const _updateData = (objectId, type, layerName) => {
    const { provinceData, localData, nepalData, nullData } = data;
    let data;
    switch (type) {
      case "province":
        data = provinceData;
        break;
      case "local":
        data = localData;
        break;
      case "nepal":
        data = nepalData;
        break;
      default:
        data = nullData;
        break;
    }
    const activeData = data.find((item) => item.id === objectId);
    setActiveData(activeData);
  };

  const _renderCategoriesList = () => {
    return (
      catData &&
      catData.map((category, catIndex) => {
        let style = {
          witdh: changeIndexToNepali(category.score) + "%",
          backgroundColor: colorScale(category.score),
        };
        const isImage = category.image.match(/\.(jpeg|jpg|gif|png)$/) !== null;
        return (
          <div className="main-list" key={catIndex}>
            <span className="dash-cat-name">
              <img
                src={
                  isImage
                    ? category.image
                    : require(`../../assets/images/${catIndex + 1}.svg`)
                }
                className="cat-icon"
                alt="cat-icon"
              />
              {category.name}
            </span>
            <ProgressBar
              bgcolor={colorScale(category.score)}
              progress={category.score}
              height={10}
            />
          </div>
        );
      })
    );
  };

  const _onLoginClick = () => {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: this.props.location },
        }}
      />
    );
  };

  const _renderSubCategories = () => {
    let content = [];
    if (!activeData) return;
    subCategories.map((subCategory) => {
      let scatId = subCategory.id.toString();
      content.push(
        <div className="pro" key={scatId}>
          <CircularProgressbar
            percentage={activeData.subCategories[scatId]}
            text={`${changeIndexToNepali(
              activeData.subCategories[scatId] || "-"
            )}`}
            styles={{
              path: { stroke: colorScale(activeData.subCategories[scatId]) },
              text: { fill: "#66d120", fontSize: "26px" },
            }}
          />
          <p>{subCategory.name}</p>
        </div>
      );
    });
    return content;
  };

  // _onChangeProv = (event) => {
  //     this.setState({ provId: event.target.value });
  // };

  const _setColor = (objectId, type) => {
    const { provinceData, localData } = data;
    switch (type) {
      case "province":
        let provinceFound = provinceData.find((p) => p.name == objectId);
        if (provinceFound) {
          return colorScale(provinceFound.percentage);
        }
        break;
      case "local":
        let lgFound = localData.find((lg) => lg.gnid == objectId);
        if (lgFound) {
          return colorScale(lgFound.percentage); //TODO score to peercent
        }
        break;
      default:
        break;
    }
    return "#bebebe";
  };
  useEffect(() => {
    if (localStorage.getItem("user")) {
      let fiscal = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
      setFyId(fiscal ? fiscal : localStorage.getItem("fiscalYear"));
    }
    _getFiscalyear();
    // _getProvince();

    _getCategories();
    _getSubCategories();
    _getHomeData();
  }, []);

  const getEvaluationSummary = (summary) => {
    let sum = [];
    let first = 0;

    for (let i = 0; i < summary.length; i++) {
      sum.push(summary[i][1]);
    }
    for (let i = 0; i < sum.length; i++) {
      first += sum[i];
    }

    let sum2 = [];
    let first2 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum2.push(summary[i][2]);
    }
    for (let i = 0; i < sum2.length; i++) {
      first2 += sum2[i];
    }

    let sum3 = [];
    let first3 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum3.push(summary[i][3]);
    }
    for (let i = 0; i < sum3.length; i++) {
      first3 += sum3[i];
    }

    let sum4 = [];
    let first4 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum4.push(summary[i][4]);
    }
    for (let i = 0; i < sum4.length; i++) {
      first4 += sum4[i];
    }

    let sum5 = [];
    let first5 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum5.push(summary[i][5]);
    }
    for (let i = 0; i < sum5.length; i++) {
      first5 += sum5[i];
    }

    let sumData = ["कुल जम्मा"];
    sumData.push(first, first2, first3, first4, first5);
    let summaryModified = summary;
    summaryModified.push(sumData);
    return summaryModified;
  };

  const loadMap = () => {
    let provinceMapRes = provinceMapJson;
    let provinceMapGeo = {
      type: "FeatureCollection",
      features: [],
    };
    provinceMapRes.response.map((province) => {
      provinceMapGeo.features.push({
        type: "Feature",
        geometry: province.geometry,
        properties: {
          province: province.name,
        },
      });
    });

    let lgMapRes = localMapJson;
    let lgMapGeo = {
      type: "FeatureCollection",
      features: [],
    };
    lgMapRes.response.map((lg) => {
      lgMapGeo.features.push({
        type: "Feature",
        geometry: lg.geometry,
        properties: {
          gnid: lg.gnid,
          palika: lg.name,
        },
      });
    });
  };
  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex justify-content-center my-5">
          {" "}
          <BounceLoader color="#1f8cd5" />
        </div>
      ) : (
        <section className="home detail">
          <Row className={"align-items-center"}>
            <Col>
              <div className="home-title">
                <span className="">FRA |</span>
                <span
                  className=""
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "black",
                    marginLeft: "5px",
                  }}
                >
                  Home
                </span>
              </div>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <Input
                  type="select"
                  name="fselect"
                  id="fiscalYearSelect"
                  value={fyId}
                  onChange={(e) => _handleFiscalYearChange(e)}
                >
                  <option value={0} disabled selected>
                    आर्थिक वर्ष चयन गार्नुहोस
                  </option>
                  {fyList.length > 0 &&
                    fyList.map((fy, index) => {
                      return (
                        <option key={fy.id} value={fy.id}>
                          आर्थिक वर्ष {fy.name}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
          {isDataLoading ? (
            <div className="w-100 d-flex justify-content-center my-5">
              {" "}
              <BounceLoader color="#1f8cd5" />
            </div>
          ) : (
            <>
              <DashBlock data={checkData} />
              <div className="chart-section">
                <Row>
                  <Col sm="4">
                    <div className="cat-list card-layout">
                      <h3 className="sub-heading">
                        मूल्याङ्कनका विषयक्षेत्रहरु{" "}
                      </h3>
                      <div className="main-list">
                        <span className="dash-cat-name-title"></span>
                        <span className="dash-cat-score-title">
                          स्कोर प्रतिशत
                        </span>
                      </div>
                      {_renderCategoriesList()}
                    </div>
                  </Col>
                  <Col sm="8">
                    <div className="card-layout">
                      <h3 className="sub-heading d-flex justify-content-center text-center m-0">
                        मूल्याङ्कनका विषयक्षेत्रहरु{" "}
                      </h3>
                      <RadarChart
                        outerRadius={150}
                        width={600}
                        height={400}
                        data={catData}
                      >
                        <PolarGrid />
                        <PolarAngleAxis dataKey="name" />
                        <PolarRadiusAxis angle={90} domain={[0, 100]} />
                        <Radar
                          name="प्राप्ताङ्क"
                          dataKey="score"
                          stroke="#0ba711"
                          fill="transparent"
                          fillOpacity={0.6}
                        />
                        <Legend />
                      </RadarChart>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="chart-section">
                <SummaryTable
                  title={"मूल्यांकनको सारांश"}
                  comments={
                    summary && summary.length > 0
                      ? getEvaluationSummary(summary)
                      : summary
                  }
                />
              </div>
              <div className="chart-section">
                <CustomTable
                  categories={catData}
                  title={"अधिकतम नतिजा प्राप्त गर्ने"}
                  comments={topData}
                />
              </div>
              <div className="chart-section">
                <CustomTable
                  categories={catData}
                  title={"न्यूनतम नतिजा प्राप्त गर्ने"}
                  comments={latestData}
                />
              </div>
            </>
          )}
        </section>
      )}
    </>
  );
}
export default withRouter(Home1);
